let mutations = {
  addLog (state, data) {
    state.loading = true
    state.requestLog.push(data.request)
  },
  removeLog (state, data) {
    state.requestLog.splice(state.requestLog.indexOf(data.request), 1)
    if(state.requestLog.length == 0){
      state.loading = false
    }
  }


}
export default mutations



// WEBPACK FOOTER //
// ./src/store/request/mutations.js